import ApiPage from '../api-page';


class ContractApplicationPage extends ApiPage {

}


export default ContractApplicationPage;
